import { FC } from 'react';
import { cva } from 'class-variance-authority';
import clsx from 'clsx';
import ProfileAction from '@/features/ProfileAction/ProfileAction';

interface Props {
  className?: string;
  title?: string;
  subtitle?: string;
}

export const ImagesEmpty: FC<Props> = ({ className, title = '', subtitle }) => {
  return (
    <div className={clsx(cvaRoot(), className)}>
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
      <div className={clsx(cvaSpanItem(), cvaAction())}>
        <ProfileAction title={title} subtitle={subtitle} />
      </div>
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
      <div className={clsx(cvaGridItem(), cvaSpanItem())} />
    </div>
  );
};

const cvaRoot = cva([
  'ImagesEmpty-cvaRoot',
  'text-center',
  'grid gap-1.6 grid-cols-12 grid-rows-[44rem_32rem]',
  'sm-max:flex sm-max:flex-wrap sm-max:gap-1.2',
]);

const cvaGridItem = cva([
  'ImagesEmpty-cvaGridItem ',
  'flex justify-center items-center order-2',
  'md-max:w-[calc(50%-0.8rem)] md-max:min-h-[32rem] sm-max:w-full',
  'border-4 border-cGray1100 rounded-[2.4rem] md-max:rounded-[1.6rem]',
  'text-2.8-800 text-cGray700',
  'md-max:child-1:hidden md-max:child-3:hidden md-max:child-4:hidden md-max:child-5:hidden',
]);

const cvaSpanItem = cva([
  'ImagesEmpty-cvaSpanItem',
  'md-max:w-full',
  'col-span-3 child-1:col-span-4 child-2:col-span-4 child-3:col-span-4',
  'md-max:child-2:!col-span-full md-max:child-6:col-span-6 md-max:child-7:col-span-6',
]);

const cvaAction = cva([
  'ImagesEmpty-cvaAction',
  'relative',
  'order-2 sm-max:!order-1',
]);
